import { computed, Injectable, linkedSignal, signal } from '@angular/core';
import { submissionDocumentTypesTokenizer } from '../store';
import {
  AddDocumentTypeDialogData,
  SDocumentType,
  SDocumentTypePayload,
} from '../types';
import { OpenDialogState } from '@data-access/shared';

import { SDocumentTypeDialogComponent } from '../dialogs';

@Injectable()
export class SubmissionDocumentTypesFacadeService {
  private readonly _submissionDocumentTypesTokenizer =
    submissionDocumentTypesTokenizer();

  $isLoading = computed(() =>
    this._submissionDocumentTypesTokenizer.$isLoading(),
  );

  $submission = linkedSignal({
    computation: (submission) => submission,
    source: this._submissionDocumentTypesTokenizer.$submission,
  });

  $documentTypes = computed(() =>
    this._submissionDocumentTypesTokenizer.$data(),
  );

  $documentList = computed(() =>
    this._submissionDocumentTypesTokenizer.$documentList(),
  );
  $attributeList = computed(() =>
    this._submissionDocumentTypesTokenizer.$attributeList(),
  );
  $entityType = computed(() =>
    this._submissionDocumentTypesTokenizer.$entityType(),
  );

  loadSubmissionDocumentTypes(entity_type: string, workspaceTypeId: string) {
    this._submissionDocumentTypesTokenizer.loadSubmissionDocumentTypes(
      entity_type,
      workspaceTypeId,
    );
  }

  openDocumentTypeDialog(
    mode: 'Create' | 'Edit',
    entityType: string,
    documentType?: SDocumentType,
  ): void {
    const _dialogData: AddDocumentTypeDialogData = {
      $attributes: this.$attributeList,
      $canCloseDialog: this._submissionDocumentTypesTokenizer.$canCloseDialog,
      $documentType: signal(documentType ?? ({} as SDocumentType)),
      $documentTypes: this.$documentList,
      $error: this._submissionDocumentTypesTokenizer.$error,
      $mode: signal(mode),
      $sDocumentTypes: this.$documentTypes,
      $isLoading: this._submissionDocumentTypesTokenizer.$isLoading,
      callbacks: {
        save: this._addSubmissionDocumentType.bind(this),
      },
      entityType: entityType,
    };
    this._openDialog(_dialogData);
  }

  private _openDialog<T>(data: T): void {
    const _dialogState: OpenDialogState = {
      component: () => SDocumentTypeDialogComponent,
      componentData: data,
      type: 'documentTypes',
    };
    this._submissionDocumentTypesTokenizer.openDocumentTypeDialog(_dialogState);
  }

  private _addSubmissionDocumentType(documentType: SDocumentTypePayload) {
    this._submissionDocumentTypesTokenizer.addSubmissionDocumentType(
      documentType,
    );
  }
}
